export default function AboutPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-16">
      <h1 className="text-3xl font-semibold text-[var(--maroon-light)] mb-6">
        About RESEATO
      </h1>
      <p className="text-white/75 leading-relaxed">
        RESEATO helps you book the best tables at top rated restaurants in SM
        City and SM Seaside Cebu. Skip the line, enjoy the dine—and suggest
        what&apos;s best.
      </p>
    </div>
  );
}
